
















import {Component, Prop, Watch, Mixins} from "vue-property-decorator";
import DeeplinksMixin from "../../mixins/Deeplinks";
import { videoPlyr } from "../../common/plyrHelper";

@Component
export default class Description extends Mixins(DeeplinksMixin) {
    @Prop() text: string;
    @Prop({ required: false, default: false }) dontCut: boolean;

    showMore = false;
    isLimited = false;
    limit = 150;

    @Watch('text')
    onTextChange() {
        this.$nextTick(() => {
            this.checkLimit();
        });
    }

    mounted() {
        this.checkLimit();
        this.processDeeplinks(this.$refs['content'] as HTMLElement);
        this.processYoutubeVideo(this.$refs['content'] as HTMLElement);
    }

    checkLimit() {
        if (this.dontCut) {
            this.showMore = false;
            return;
        }
        this.isLimited = (this.$refs['content'] as HTMLElement).clientHeight > this.limit;
        this.showMore = !this.isLimited;
    }

    clickMore() {
        this.showMore = !this.showMore;
    }

    processYoutubeVideo(content: HTMLElement) {
        const iframes = content.querySelectorAll('iframe.video');

        iframes.forEach(iframe  => {
            // Для работы plyr необходима обертка вокруг iframe
            const wrapper = document.createElement('div');
            iframe?.parentNode?.insertBefore(wrapper, iframe);
            wrapper.appendChild(iframe);

            videoPlyr(wrapper as HTMLElement);
        });
    }
}
